// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import iView from 'iview';
import i18n from '@/locale';
import config from '@/config';
import axios from '@/libs/http';
import '@/assets/icons/iconfont.css';
import 'iview/dist/styles/iview.css';
//import tinymce from 'vue-tinymce-editor';
import msgUtil from '@/components/common/msg-util';
import tinymce from '@/components/vue-tinymce-editor/TinymceVue.vue';

// if (env === 'development') import('@/mock');

Vue.use(iView, {
    i18n: function(path, options) {
        let value = i18n.t(path, options);
        if (value !== null && value !== undefined) {
            return value;
        }
        return '';
    },
});

msgUtil.message = i18n.t('message');
Vue.prototype.$msgUtil = msgUtil;

//date格式化方法
Date.prototype.format = function(fmt) {
    let o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'H+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};

Vue.config.productionTip = false;
Vue.component('tinymce', tinymce);
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    axios,
    router,
    store,
    i18n,
    render: h => h(App),
});
